import { useSlicerVariables, useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { resolveTemplate } from "../Utils/resolveTemplate";
import { sanitizeWidgetHtml } from "../Utils/sanitizeHtml";

export function TextWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const slicerValues = useSlicerVariables();
  const rawContent = data?.type === "text" ? data.spec.display.content : "";
  // The content is HTML, so every substituted value is escaped before it lands in it.
  const { resolved } = resolveTemplate(rawContent, slicerValues, { escapeHtml: true });

  // The text body scrolls, so the info cluster floats on a frame outside the scroller.
  // Stored content is untrusted at render time — sanitize before injecting.
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <span className="widget-floating-info">
        <WidgetInfoButton id={id} />
      </span>
      <div className="text-widget" data-grid-id={id}>
        <div
          className="text-widget-content"
          dangerouslySetInnerHTML={{ __html: sanitizeWidgetHtml(resolved) }}
        />
      </div>
    </div>
  );
}
